import { createContext, useContext } from 'react';

// Per-user facts the shell learns at mount time (from the Rails view) that pages deep in the tree
// need without prop-threading. Add fields here rather than passing them page by page.
//
// The sysadmin roles all pass the SPA's gate, but ContentManager reaches only the content pages
// and SupportManager only the support pages (authorize_content_manager! / authorize_support_manager!),
// so the nav shows each role the sections it can open.
export interface SPAUser {
  canManageContent: boolean;
  canManageSupport: boolean;
  // The raw LTI sync log is Sysadmin-only (LmsSyncEventsController), narrower than the support gate.
  canViewSyncLog?: boolean;
  // The enable_print_tools flag: the lesson tab row offers Print Tools.
  showPrintTools: boolean;
  showSearch: boolean;
}

const SPAUserContext = createContext<SPAUser>({
  canManageContent: true,
  canManageSupport: true,
  canViewSyncLog: false,
  showPrintTools: false,
  showSearch: false,
});

export const SPAUserProvider = SPAUserContext.Provider;

export const useSPAUser = () => useContext(SPAUserContext);
